import script from "./SearchClient.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchClient.vue?vue&type=script&lang=ts&setup=true"

import "./SearchClient.vue?vue&type=style&index=0&id=7fbdee06&lang=scss"

const __exports__ = script;

export default __exports__